import { React, useEffect, useState, useContext } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { FormGroup, FormControlLabel, Switch } from "@mui/material";
import axios from "axios";
import { Multiselect, ResearchApplicantTable, ResearchApplicantOverview,  EnhancedAutocomplete } from "..";
import { Select } from "@mui/material";
import { UserContext } from "../../App";
import "../../styles/ResearchApplicantSearch.css";

function ResearchApplicantSearch() {
  const { userType, username } = useContext(UserContext);
  const [gradYear, setGradYear] = useState([]);
  const [csType, setCSType] = useState([]);
  const [updateTable, setUpdateTableHook] = useState(false);
  const [availableGradYears, setAvailableGradYears] = useState([]);
  const [like, setLike] = useState([]);
  const [positionNames, setPositionNames] = useState([]);
  const [updateOffset, setUpdateOffset] = useState(false);
  const [availablePositions, setAvailablePositions] = useState([]);
  const [showUnviewed, setShowUnviewed] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState({});
  const [applicants, setApplicants] = useState([]);
  const [updateLike, setUpdateLike] = useState(false);
  const [updateView, setUpdateView] = useState(false);
  const [editedTable, setEditedTable] = useState(false);
  const [applicantOffset, setApplicantOffset] = useState(0);
  const [handleChange, setHandleChange] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const setUpdateTable = (value) => {
    setUpdateTableHook(value);
    setSelectedApplicant({});
  };

  // To only update the applicants, not unselecting applicants and not going back to page 1
  useEffect(() => {
    showApplicantSearchResults();
  }, [updateLike, updateView, editedTable, applicantOffset]);

  // To update the research positions, unselect research position, and go back to page 1
  useEffect(() => {
    setUpdateOffset(!updateOffset);
    setCurrentPage(0);
    setApplicantOffset(0);
    showApplicantSearchResults();
  }, [
    csType,
    gradYear,
    positionNames,
    like,
    updateTable,
    showUnviewed
  ]);

  useEffect(() => {
    axios.get("/company/graduationYears").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableGradYears(data.gradYears);
      } else {
        return setAvailableGradYears([]);
      }
    });
  }, [updateTable]);

  useEffect(() => {
    const body = new FormData();
    body.append("username", username);
    axios.post("/faculty/positions", body).then((res) => {
      const data = res.data;
      //console.log(data);
      if (data.success) {
        setAvailablePositions(data.positions);
      } else {
        return setAvailablePositions([]);
      }
    });
  }, [updateTable]);

  const showApplicantSearchResults = () => {
    const body = new FormData();
    body.append("gradYear", gradYear);
    body.append("csType", csType);
    body.append("username", username);
    body.append("like_filter", like);
    body.append("positionNames", positionNames);
    body.append("viewedStatus", showUnviewed === false);


    axios.post("/faculty/searchApplicants", body).then((res) => {

      const data = res.data;
      if (data.success) {
        setApplicants(data.applicants);
        if (applicantOffset == 0) {
          setSelectedApplicant(data.applicants[0]);
        }
        else {
          setSelectedApplicant(data.applicants.filter(applicant => applicant.applicationId == applicantOffset)[0]);
        }
      } else {
      }
    });
  };

  const majorMinorData = {
    label: "Major/Minor",
    options: ["Major", "Minor"],
    value: csType,
    setter: setCSType,
  };

  const gradYearData = {
    label: "Graduation Year",
    options: availableGradYears,
    value: gradYear,
    setter: setGradYear,
  };

  const likeData = {
    label: "Like Status",
    options: ["Like", "Dislike"],
    value: like,
    setter: setLike,
  };

  function makeMultiselect(type) {
    let data = {};
    if (type === "Graduation Year") {
      data = gradYearData;
    }
    else {
      return;
    }
    

    return (
      <Multiselect
        label={data.label}
        options={data.options}
        selectedValue={data.value}
        selectedSetter={data.setter}
        key={data.label}
      />
    );
  }


  function makeSingleSelect(type) {
    let data = {};
    if (type === "Major/Minor") {
      data = majorMinorData;
    } else if (type === "Like Status") {
      data = likeData;
    } else {
      return;
    }

    return (
      <Multiselect
        label={data.label}
        options={data.options}
        selectedValue={data.value}
        selectedSetter={data.setter}
        key={data.label}
        multiStatus={false}
      />
    );

  }

  // const compileResumes = () => {
  //   const body = new FormData();
  //   // Get all pids from the students list
  //   const pids = applicants.map((applicant) => applicant.resume);
  //   body.append("pids", pids);
  //   axios.post("/student/compileResumes", body, { responseType: "blob" }).then((res) => {
  //     // If the file exists
  //     if (res.data.size === 0) {
  //       alert("No resumes found");
  //       return;
  //     }
  //     const url = window.URL.createObjectURL(new Blob([res.data]));
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = "resumes.zip";
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove(); // Remove the link element from the DOM after the download has started
  //     window.URL.revokeObjectURL(url);
  //   });
  // };

  const resetHooks = () => {
    setGradYear([]);
    setCSType([]);
    setLike([]);
    setPositionNames([]);
    setShowUnviewed(false);
  };

  function showSearchMultiDropdowns() {
    return ["Graduation Year"].map((dataType) => {
      return makeMultiselect(dataType);
    });
  }

  function showSearchSingleDropdowns()
  {
    return ["Major/Minor", "Like Status"].map((dataType) => {
      return makeSingleSelect(dataType);
    });

  }
  return (
    <div className="ApplicantSearch bg-brand-tertiary">
      <div className="ApplicantSearch-container flex flex-col p-8 h-full">
        <div className="ApplicantSearch-topContainer flex flex-wrap">    
          {(userType !== "faculty") ? null : (
            <Multiselect
              label="Positions"
              placeholder="Positions"
              options={availablePositions}
              selectedValue={positionNames}
              selectedSetter={setPositionNames}
              isMultiSelect={true}
            />
          )}

          {showSearchMultiDropdowns()}
          {showSearchSingleDropdowns()}

          <FormGroup
              sx={{
                bgcolor: "white",
                borderRadius: 4,
                height: 44,
                mb: 2,
              }}
              className="search-button mr-4"
            >
              <FormControlLabel
                control={<Switch checked={showUnviewed} />}
                label="Show Unviewed Applications"
                onChange={(event, checked) => setShowUnviewed(checked)}
                className="flex justify-center mx-4"
              />
          </FormGroup>

          {/* <button
            type="button"
            className="search-button px-4 h-11 mb-4 mr-4 text-center py-2"
            onClick={compileResumes}
          >
            Compile Current Resumes
          </button> */}

          <button
            type="button"
            className="search-button px-4 h-11 mb-4 text-center py-2"
            onClick={resetHooks}
          >
            Reset Search
          </button>
        </div>
        <div className="ApplicantSearch-bottomContainer flex h-full">
          <div className="ApplicantSearch-leftContainer">
            <ResearchApplicantTable
              applicants={applicants}
              selectedApplicant={selectedApplicant}
              setApplicant={setSelectedApplicant}
              userType={userType}
              updateTable={updateTable}
              setUpdateTable={setUpdateTable}
              updateLike={updateLike}
              setUpdateLike={setUpdateLike}
              updateOffset={updateOffset}
              updateView={updateView}
              setUpdateView={setUpdateView}
              editedTable={editedTable}
              setEditedTable={setEditedTable}
              setApplicantOffset={setApplicantOffset}
              handleChange={handleChange}
              setHandleChange={setHandleChange}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
            />
          </div>
          <div className="ApplicantSearch-rightContainer">
            <div>
              <ResearchApplicantOverview applicant={selectedApplicant} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResearchApplicantSearch;
